import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_CHAT } from '@/modules/chat/router';
import { useLocale } from '@/modules/locale/model/locale';
import { chatService } from '@/services/chat';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useChatSentenceTranslate() {
    const router = useAppRouter();
    const route = useRoute();
    const crudAction = useCrudActions();

    const { localeSupportedOptions, getListSupported } = useLocale();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        locale: null,
        hasData: false,
        content: ''
    });

    const validations = {
        content: { required },
        locale: { required }
    };

    const v$ = useVuelidate(validations, model);

    const beforeFetch = async () => {
        await getListSupported();
        if (!localeSupportedOptions.value.length) {
            router.push(ROUTE_NAME_CHAT.SENTENCE.INDEX);
            return;
        }
    };

    const fetch = crudAction.executeAction({
        canExecute: () => model.locale != null,
        request: () => chatService.sentence.getText(model.id, model.locale),
        onSuccess: ({ data }) => {
            model.hasData = true;
            model.content = data.content;
        },
        onError: () => {
            model.hasData = false;
            model.content = '';
        }
    });

    const actions = {
        updateText: crudAction.excuteAndNotify({
            validator: v$,
            request: () => chatService.sentence.updateText(model.id, model.locale, model.content),
            onSuccess: fetch
        }),
        removeText: crudAction.excuteAndNotify({
            request: () => chatService.sentence.removeText(model.id, model.locale),
            onSuccess: fetch
        })
    };

    return { v$, model, localeSupportedOptions, fetch, beforeFetch, actions };
}
